export default (number, length) => {
    return number.toString().slice(0, length);
};